export default __webpack_public_path__ + "static/media/babavelisekiz3.cca9ddb4.jpg";